import gql from 'graphql-tag';

export const UPSERT_SETTINGS = gql`
  mutation updateSettings($key: String!, $value: jsonb!, $isPublic: Boolean!) {
    insert_settings_one(
      object: { key: $key, value: $value, is_public: $isPublic }
      on_conflict: {
        update_columns: [value, is_public]
        constraint: settings_pkey
      }
    ) {
      id: key
      value
      is_public
    }
  }
`;

export const GET_SETTINGS_BY_KEY = gql`
    query getSettingByKey($key: String!) {
        settings_by_pk(key: $key) {
            id: key
            value
            is_public
        }
    }
`;
